import StatusChip from '../../../components/StatusChip';
import { OVERALL_PROFORMA_INVOICE_STATUS_COLORS } from '../../../constants/proformaInvoiceStatusConstants.js';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const ProformaInvoiceStatusChip = ({ status, size = 'small', variant = 'filled', className, sx }) => {
  const { proformaInvoices: pi } = useTranslatedMessages();
  const label = pi?.status_labels?.[status];
  const color = OVERALL_PROFORMA_INVOICE_STATUS_COLORS[status];

  if (!label || !color) {
    console.warn(`Unknown status: ${status}`);
    return null;
  }

  return <StatusChip color={color} label={label} size={size} variant={variant} className={className} sx={sx} />;
};

export default ProformaInvoiceStatusChip;
